import { ISelectOptions } from '@/types/FmsTypes';
import moment from 'moment';
import { ValidateErrorEntity } from 'rc-field-form/es/interface';
import BigNumber from "bignumber.js";

/**
 * url参数解析
 * @example String "https://mp.csdn.net?id=123456&a=b"
 * @return Object {id:"123456",a:"b"}
 */
export function urlParse(url: string): object {
	let obj: any = {};
	/*
	 * 正则匹配
	 * [?&]:匹配?或&其一
	 * [^?&]:非?或非&
	 * */
	let reg = /[?&][^?&]+=[^?&]+/g;
	let arr = url.match(reg);
	if (arr) {
		arr.forEach((item) => {
			let tempArr = item.substring(1).split('=');
			let key = tempArr[0];
			let val = tempArr[1];
			obj[key] = val;
		});
	}
	return obj;
}

/**
 * 数字补零   返回num字符串
 */
export function formatNum(num: string | number | undefined): string {
	if (num === undefined || num === null || isNaN(+num)) {
		return '0.00';
	}
	if (typeof num === 'number') {
		num = String(num);
	}

	num = num.replace(/[^0-9|\.]/g, ''); //清除字符串中的非数字非.字符

	if (/^0+/)
		//清除字符串开头的0
		num = num.replace(/^0+/, '');
	if (!/\./.test(num))
		//为整数字符串在末尾添加.00
		num += '.00';
	if (/^\./.test(num))
		//字符以.开头时,在开头添加0
		num = '0' + num;
	num += '001'; //在字符串末尾补零
	// let newNum = num.match(/\d+\.\d{3}/);
	// return newNum ? (+newNum[0]).toFixed(2) : '0.00';
	return (+num).toFixed(2);
}

/**
 *根据要查找的key返回这一项 （递归查找）
 * @param {Array}  array 要查找的源数组
 * @param {string} code   唯一标识
 * @param {string} key   要查找的键名， 和code对应的  默认id
 * @param {Boolean} filter   查找是否过滤掉不要在左侧菜单展示的页面
 */

export function forFind(array: any[], code: string, key: string = 'id', filter: boolean = false) {
	//console.log(array);

	for (const item of array) {
		if (item[key] === code && (filter ? item.isShow : true)) {
			return item;
		}
		if (item.children && item.children.length > 0) {
			let forFindRet: any = forFind(item.children, code, key, filter);
			if (forFindRet) {
				return forFindRet;
			}
		}
	}
}

//re-from 错误校验提示信息方法
export function getFormValidatorErrText(error: ValidateErrorEntity) {
	let { errorFields } = error;
	for (let key in errorFields) {
		if (errorFields[key]?.errors?.length > 0) {
			return errorFields[key]?.errors[0];
		}
	}
	return '未知问题!';
}

// 针对维修工单可以开负数的情况 计算公式
export function repairFormatNum(num: string | number | undefined) {
	if (num === undefined || num === null || isNaN(+num)) {
		return '0.00';
	}
	if (typeof num === 'number') {
		num = String(num);
	}

	num = num.replace(/[^0-9|\.\-]/g, ''); //清除字符串中的非数字非.字符

	if (/^0+/)
		//清除字符串开头的0
		num = num.replace(/^0+/, '');
	if (!/\./.test(num))
		//为整数字符串在末尾添加.00
		num += '.00';
	if (/^\./.test(num))
		//字符以.开头时,在开头添加0
		num = '0' + num;
	num += '001'; //在字符串末尾补零
	// let newNum = num.match(/\d+\.\d{3}/);
	// return newNum ? (+newNum[0]).toFixed(2) : '0.00';
	// if (+num <= 0) {
	//     return `-${(+num).toFixed(2)}`
	// } else {
	return (+num).toFixed(2);
	// }
}

//关闭浏览器页签
export function closeWebPage() {
	if (navigator.userAgent.indexOf('MSIE') > 0) {
		// IE
		if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
			// IE6
			window.opener = null;
			window.close();
		} else {
			// IE6+
			window.open('', '_top');
			window.top?.close();
		}
	} else if (
		navigator.userAgent.indexOf('Firefox') > 0 ||
		navigator.userAgent.indexOf('Presto') > 0
	) {
		// FF和Opera
		window.location.href = 'about:blank';
		window.close(); // 火狐默认状态非window.open的页面window.close是无效的
	} else {
		window.opener = null;
		window.open('', '_self', '');
		window.close();
	}
}

// 授信类型转义
export function creditFlagRender(v: number) {
	return v === 2 ? '结转' : v === 1 ? '记账' : v === 0 ? '现结' : '';
}

//js对LocalDateTime时间的格式化成yyyy-MM-dd HH:mm:ss
export function formatLocalDateTime(arr: number[]) {
	var time = [];
	if (arr == null) {
		return "";
	}
	else {
		for (var i = 0; i < arr.length; i++) {
			if (arr[i] < 10) {
				time[i] = "0" + arr[i];
			}
			else {
				time[i] = arr[i];
			}
		}
		if (arr.length == 5) {
			var getFormatTime = time[0] + "-" + time[1] + "-" + time[2] + "\t" + time[3] + ":" + time[4] + ":" + "00";
		} else {
			var getFormatTime = time[0] + "-" + time[1] + "-" + time[2] + "\t" + time[3] + ":" + time[4] + ":" + time[5];
		}

		return getFormatTime;
	}
}

//时间戳格式化成yyyy-MM-dd HH:mm:ss
export function timestampToTime(timestamp: number) {
	var date = new Date(timestamp);
	var date = new Date(timestamp);
	var Y = date.getFullYear() + '-';
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	var hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
	var mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
	var ss = date.getSeconds() < 10 ? '0' + date.getDate() : date.getSeconds();
	return Y + M + D + ' ' + hh + ':' + mm + ':' + ss;
}

/**
 * 根据名称 获取 val
 * export enum StatusEnum {
 *     processing = '进行中',
 *     success = '完成',
 *     fail = '失败',
 * }
 *
 * enumGetVal('processing',StatusEnum ) // 进行中
 *
 * @param name name
 * @param enumItem 枚举
 */
export function enumGetVal<T>(name: string, enumItem: { [s: string]: T }): String {
	for (const [pk, pv] of Object.entries(enumItem)) {
		if (pk === name) {
			return pv as unknown as string
		}
	}
	return ''
}

/**
 * 枚举转 option
 * export enum StatusEnum {
 *     processing = '进行中',
 *     success = '完成',
 *     fail = '失败',
 * }
 * ********************************
 * [
 *     {  "label": "进行中",   "value": "processing"},
 *     { "label": "完成", "value": "success"},
 *     {"label": "失败","value": "fail"}
 * ]
 *
 * @param o 枚举对象
 */
export function enumToOption<T>(o: { [s: string]: T }): ISelectOptions[] {
	const arr: ISelectOptions[] = []
	for (const [pk, pv] of Object.entries(o)) {
		arr.push({ label: pv as unknown as string, value: pk })
	}
	return arr

}


//时间转换
export function timeShift(arr: any[]) {
	return `${arr[0]}-${arr[1].toString().padStart(2, '0')}-${arr[2].toString().padStart(2, '0')} ${arr[3].toString().padStart(2, '0')}:${arr[4]
		.toString()
		.padStart(2, '0')}:${arr[5] ? arr[5].toString().padStart(2, '0') : '00'}`
}

//返回日期格式为YYYY-MM-DD HH:mm
export function momentFormat(text: string | number[], format = "YYYY-MM-DD HH:mm:ss") {
    if(Array.isArray(text)){
        text =  `${text[0]}-${text[1]}-${text[2]} ${text[3]}:${text[4]}:${text[5]??0}`
    }

    return text ? moment(text).format(format) : text
}

//获取随机字符串
export function getRandomStr(length = 32) {
	let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	let maxPos = chars.length
	let _string = ''
	for (let i = 0; i < length; i++) {
		_string += chars.charAt(Math.floor(Math.random() * maxPos))
	}
	return _string
}


export function moneyFormat(num: number, decimal = 2, split = ',') {
	/*
		parameter：
		num：格式化目标数字
		decimal：保留几位小数，默认2位
		split：千分位分隔符，默认为,
		moneyFormat(123456789.87654321, 2, ',') // 123,456,789.88
	*/
	function thousandFormat(numstr: string): string {
		const len = numstr.length;
		return len <= 3 ? numstr : thousandFormat(numstr.slice(0, len - 3)) + split + numstr.slice(len - 3, len);
	}

	if (isFinite(num)) {
		if (num === 0) { // 为0
			return num.toFixed(decimal)
		} else { // 非0
			var res = ''
			var dotIndex = String(num).indexOf('.')
			if (dotIndex === -1) { // 整数
				if (decimal === 0) {
					res = thousandFormat(String(num))
				} else {
					res = thousandFormat(String(num)) + '.' + '0'.repeat(decimal)
				}
			} else { // 非整数
				// 保留decimals位小数
				const numStr = String((Math.round(num * Math.pow(10, decimal)) / Math.pow(10, decimal)).toFixed(decimal)) // 四舍五入，然后固定保留2位小数
				const decimals = numStr.slice(dotIndex, dotIndex + decimal + 1) // 截取小数位
				res = thousandFormat(numStr.slice(0, dotIndex)) + decimals
			}
			return res
		}
	} else {
		return '--'
	}
}

type bigNumberType = number | string | BigNumber
//计算
export const bigNumber = {
     // 加
     add(x: bigNumberType, y: bigNumberType) {
        x = BigNumber(x).toFixed(2)
        y = BigNumber(y).toFixed(2)
        return BigNumber(x).plus(y).toNumber()
    },
    // 减
    minus(x: bigNumberType, y: bigNumberType) {
        x = BigNumber(x).toFixed(2)
        y = BigNumber(y).toFixed(2)
        return BigNumber(x).minus(y).toNumber()
    },
    // 乘
    times(x: bigNumberType, y: bigNumberType) {
        x = BigNumber(x)
        y = BigNumber(y)
        return x.times(y).toNumber()
    },
    // 多个相乘
    multiTimes(...params: bigNumberType[]) {
        let num = BigNumber(1)
        params.forEach((x) => num = num.times(BigNumber(x)))
        return num.toNumber()
    },
    // 除
    dividedBy(x: bigNumberType, y: bigNumberType) {
        x = BigNumber(x)
        y = BigNumber(y)
        return x.dividedBy(y).toNumber()
    },
    // 多个相加
    multiAdd(...params: bigNumberType[]){
        let num = BigNumber(0)
        params.forEach((x) => num = num.plus(BigNumber(x)))
        return num.toNumber()
    },
    //保留小数
    toFixed(num: bigNumberType, x: number){
        return BigNumber(num).toFixed(x)
    }
}